import type { ReactNode } from "react";
import { eventImage, KIND_META, type CalEvent, type ImageSlot } from "@/services/events";

const ASPECT: Record<ImageSlot, string> = { horizontal: "16 / 9", square: "1 / 1", vertical: "4 / 5" };

/** Ancho sugerido (clases Tailwind) según la forma de la foto, para listas y miniaturas. */
export function thumbWidth(e: CalEvent, sizes: Record<ImageSlot | "none", string>): string {
  const img = eventImage(e);
  return sizes[img ? img.shape : "none"];
}

/** Foto completa (sin recortar) dentro de un marco fijo, con fondo difuminado de la misma imagen. */
export function FitImage({ event }: { event: Pick<CalEvent, "imageUrl" | "imageVerticalUrl" | "imageSquareUrl"> }) {
  const img = eventImage(event);
  if (!img) return null;
  return (
    <>
      <img src={img.url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover scale-125 blur-lg opacity-70" loading="lazy" />
      <img src={img.url} alt="" className="absolute inset-0 w-full h-full object-contain" loading="lazy" />
    </>
  );
}

type Props = {
  event: CalEvent;
  /** native: el marco toma la proporción de la foto (cuadrada, horizontal o vertical). fit: marco fijo y la foto se ve completa. */
  mode?: "native" | "fit";
  className?: string;
  children?: ReactNode;
};

export default function EventMedia({ event, mode = "native", className = "", children }: Props) {
  const meta = KIND_META[event.kind];
  const img = eventImage(event);
  const style = mode === "native" ? { aspectRatio: ASPECT[img ? img.shape : "horizontal"] } : undefined;
  return (
    <div className={`relative overflow-hidden bg-gradient-to-br ${meta.gradient} ${className}`} style={style}>
      {img ? (
        mode === "native" ? (
          <img src={img.url} alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        ) : (
          <FitImage event={event} />
        )
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-white/80">
          <i className={`${meta.icon} text-4xl`}></i>
        </div>
      )}
      {children}
    </div>
  );
}
